<template>
  <div>
    <loading-spinner v-if="!filmtypes" />
    <div v-if="filmtypes">
      <div class="mb-3">
        <b-button size="sm" class="mr-2" @click="selectAllRows">
          <span v-label-key="'SELECT_ALL'">Select all</span>
        </b-button>
        <b-button
          :disabled="!selected.length"
          size="sm"
          class="mr-2"
          @click="clearSelected"
        >
          <span v-label-key="'SELECT_CLEAR'">Clear selected</span>
        </b-button>
        <b-button
          :disabled="!selected.length"
          size="sm"
          class="mr-2"
          @click.prevent="enableSelected"
        >
          <span v-label-key="'SELECT_ENABLE'">Enable selected</span>
        </b-button>
        <b-button
          :disabled="!selected.length"
          size="sm"
          class="mr-2"
          @click.prevent="disableSelected"
        >
          <span v-label-key="'SELECT_DISABLE'">Disable selected</span>
        </b-button>
      </div>
      <b-table
        ref="selectableTable"
        :items="filmtypes"
        :fields="fields"
        show-empty
        hover
        responsive
        selectable
        select-mode="multi"
        selected-variant="success"
        sticky-header="500px"
        :no-border-collapse="true"
        @row-selected="onRowSelected"
      >
        <template v-slot:cell(status)="data">
          <span
            v-if="data.item.warranty_price || data.item.warranty_price === 0"
            >Enabled at {{ data.item.warranty_price }}</span
          >
          <span v-if="data.item.warranty_price == null" v-label-key="'DISABLED'"
            >Disabled</span
          >
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import $api from '@/services/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import { mapGetters } from 'vuex';

export default {
  /* eslint-disable-next-line vue/prop-name-casing, vue/require-prop-types */
  components: {
    LoadingSpinner,
  },
  props: ['chain_id', 'distributor_id', 'subdistributor_id'],
  data() {
    return {
      filmtypes: null,
      selected: [],
    };
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
    fields() {
      const fields = [
        { key: 'name', label: 'Name', labelKey: 'NAME', sortable: true },
        {
          key: 'description',
          label: 'Description',
          labelKey: 'DESCRIPTION',
          sortable: true,
        },
      ];
      if (this.chain_id) {
        fields.push({
          key: 'status',
          label: 'Status',
          labelKey: 'WARRANTY_FIELD_STATUS',
          sortable: true,
        });
      }
      fields.forEach(field => {
        if (field.labelKey) {
          field.label = this.getLabel(field.labelKey) || field.label;
        }
      });
      return fields;
    },
  },
  created() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      let url = '/v1/dashboard/warrantyfilmtypes';
      if (this.chain_id) {
        url += `?chain_id=${this.chain_id}`;
      }
      $api.get(url).then(filmtypes => {
        this.filmtypes = filmtypes;
      });
    },
    enableSelected() {
      const price = prompt(this.getLabel('WARRANTY_FILMTYPE_PRICE_QUESTION')); // eslint-disable-line no-alert
      if (price < 0 || isNaN(price)) {
        alert(this.getLabel('WARRANTY_FILMTYPE_PRICE_POSITIVE_WARNING'));
      } else {
        this.setPrice(price);
      }
    },
    disableSelected() {
      this.setPrice(null);
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    onRowSelected(items) {
      this.selected = items;
    },
    async setPrice(price) {
      const selectedFilmtypeIds = this.selected.map(ft => ft.id);
      console.log(selectedFilmtypeIds);

      await $api.post('/v1/dashboard/warrantyfilmtypes', {
        filmtype_ids: selectedFilmtypeIds,
        price,
        chain_id: this.chain_id,
        subdistributor_id: this.subdistributor_id,
        distributor_id: this.distributor_id,
      });

      this.selected.forEach(ft => {
        ft.warranty_price = price;
      });
      alert(this.getLabel('SAVED'));
    },
  },
};
</script>
